function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconLoanRegisterEcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 12.0005H9.00633M9.00033 6.0002V9.75036M16.5007 9.00033C16.5007 4.8579 13.1428 1.5 9.00033 1.5C4.8579 1.5 1.5 4.8579 1.5 9.00033C1.5 13.1428 4.8579 16.5007 9.00033 16.5007C13.1428 16.5007 16.5007 13.1428 16.5007 9.00033Z",
    stroke: "#E5A503",
    style: {
      stroke: "#E5A503",
      stroke: "color(display-p3 0.8980 0.6471 0.0118)",
      strokeOpacity: 1
    },
    strokeWidth: 1.40631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconLoanRegisterEcl);
export default __webpack_public_path__ + "static/media/warningIconLoanRegisterECL.9812bb14d4dbd76b7f6657b35839f1c8.svg";
export { ForwardRef as ReactComponent };